(() => {
  'use strict';
  // Event delegation also covers sections reloaded in Shopify's theme editor.
  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.open || !details.closest('.z-header')) return;
    document.querySelectorAll('.z-header details[open]').forEach(other => { if (other !== details && !other.contains(details)) other.open = false; });
    if (details.matches('.z-search')) details.querySelector('input')?.focus();
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.z-header details[open]').forEach(details => { details.open = false; details.querySelector('summary')?.focus(); });
  });
  document.addEventListener('click', (event) => {
    // Keep each preview in its own draft when two themes are open side by side.
    const link = event.target.closest('a[href]');
    const themeId = document.body.dataset.zThemeId;
    if (link && themeId && document.body.dataset.zPreview === 'true' && !link.getAttribute('href').startsWith('#')) {
      const target = new URL(link.href, location.href);
      if (target.origin === location.origin && !/^\/(account|checkout|customer_authentication)(\/|$)/.test(target.pathname)) {
        target.searchParams.set('preview_theme_id', themeId);
        link.href = target.href;
      }
    }
    if (!event.target.closest('.z-header')) document.querySelectorAll('.z-header details[open]').forEach(details => { details.open = false; });
    const trigger = event.target.closest('[data-z-buy]');
    if (trigger) {
      const form = document.querySelector('product-form');
      form?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'center' });
      form?.querySelector('button[name="add"]')?.focus({preventScroll:true});
    }
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (form.matches('.z-finder__form, .z-search__panel form') && document.body.dataset.zPreview === 'true') {
      let input = form.querySelector('input[name="preview_theme_id"]');
      if (!input) { input=document.createElement('input'); input.type='hidden'; input.name='preview_theme_id'; form.append(input); }
      input.value=document.body.dataset.zThemeId;
    }
    if (!form.matches('.z-quick-form')) return;
    event.preventDefault();
    const button=form.querySelector('button[type="submit"]');
    if (!button || button.disabled) return;
    const original=button.textContent, error=form.querySelector('.z-form-error');
    button.disabled=true; button.textContent='Adding…'; error.hidden=true;
    const drawer=document.querySelector('cart-drawer');
    const body=new FormData(form);
    body.append('sections','cart-drawer,cart-icon-bubble');
    body.append('sections_url',location.pathname);
    try {
      const response=await fetch(window.routes.cart_add_url,{method:'POST',body,headers:{'Accept':'application/json'}});
      const data=await response.json();
      if (!response.ok || data.status) throw new Error(data.description || 'This item could not be added. Please try again.');
      if (drawer && data.sections && typeof drawer.renderContents==='function') {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
      } else location.assign(window.routes.cart_url || '/cart');
    } catch(err) {
      error.textContent=err.message || 'Unable to add this item. Please try again.'; error.hidden=false;
    } finally {button.disabled=false;button.textContent=original;}
  });
  function bindSticky() {
    const bar=document.querySelector('[data-z-sticky]'), form=document.querySelector('product-form');
    if (!bar || !form || bar.dataset.bound) return;
    bar.dataset.bound='true';
    new IntersectionObserver(([entry]) => {bar.hidden=entry.isIntersecting || entry.boundingClientRect.top>0;},{threshold:0}).observe(form);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',bindSticky); else bindSticky();
  document.addEventListener('shopify:section:load',bindSticky);
})();
